module.exports = __webpack_public_path__ + "img/Tobola2019.3b0477d3.jpg";